import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Col, Form, Radio, Row, Tooltip } from 'antd';
import { Loader } from 'components/Global';
import InputNumberField from 'components/Global/InputNumberField';
import GlobalPayPeriod from 'components/Global/PayPeriod';
import SelectDropdown from 'components/Global/SelectDropdown';
import { useState } from 'react';
import { PayGroupImage } from 'utils/svgs';
import { invalidText } from 'utils/utils';
import styles from './index.module.scss';
import './index.scss';

type Props = {
	selectedYear: string;
	selectedPayPeriod: string;
	selectedPayGroup: any;
	handlePayPeriod: (value: string) => void;
	handleSelectedYear: (number: string) => void;
	handlePayGroup: (number: any) => void;
	payGroupOptions: any;
	remainingEmployees: any;
	addEmployee: (id: string) => void;
	removeEmployee: (id: string) => void;
	payGroupError: {
		payPeriod: boolean;
		payGroup: boolean;
		exchangeRate: boolean;
	};
	isPayrollDetailsLoading: boolean;
	exchangeRate: any;
	handleCurrencyChange: (value: number | null) => void;
	edit: boolean;
	onlyView: boolean;
	headerData: any;
	usdCurrency: boolean;
	currencyError: boolean;
	payGroupEmployees: any;
	isImportData: boolean;
	showSteps: boolean;
	isPayPeriodDisabled: boolean;
};

const PayGroupSetupComponent = (props: Props) => {
	const {
		selectedPayPeriod,
		selectedYear,
		handlePayPeriod,
		handleSelectedYear,
		payGroupOptions,
		selectedPayGroup,
		handlePayGroup,
		remainingEmployees,
		addEmployee,
		removeEmployee,
		payGroupError,
		isPayrollDetailsLoading,
		edit,
		usdCurrency,
		onlyView,
		exchangeRate,
		handleCurrencyChange,
		currencyError,
		payGroupEmployees,
		isImportData,
		showSteps,
		isPayPeriodDisabled,
	} = props;

	const [radioValue, setRadioValue] = useState('employee');
	const [isLastPayroll, setIsLastPayroll] = useState(false);

	const handleRadioChange = (e: any) => {
		setRadioValue(e.target.value);
	};

	return (
		<>
			<div className={styles['side-drawer-body']}>
				<Form
					name="basic"
					className={styles['side-drawer-form']}
					autoComplete="off"
				>
					{/* First Row */}
					<Row>
						<Col span={15}>
							<Row
								style={{
									paddingRight: '100px',
									paddingLeft: '30px',
								}}
							>
								<Col span={24} style={{ marginBottom: '4px' }}>
									<GlobalPayPeriod
										selectedYear={selectedYear}
										selectedPayPeriod={selectedPayPeriod}
										handlePayPeriod={(value) =>
											handlePayPeriod(value)
										}
										handleSelectedYear={(value) =>
											handleSelectedYear(value)
										}
										isRow={true}
										isPayPeriodRequired={true}
										isPayPeriodDisabled={
											edit || isPayPeriodDisabled
										}
										isYearRequired={true}
										payPeriodError={payGroupError.payPeriod}
										yearError={false}
										isYearLoading={isPayrollDetailsLoading}
										isPayPeriodLoading={
											isPayrollDetailsLoading
										}
									/>
								</Col>
								{invalidText(selectedPayPeriod) ? (
									<></>
								) : (
									<>
										{' '}
										<Col span={13}></Col>
										<Col
											span={11}
											style={{
												marginBottom: '2px',
												fontSize: '13px',
											}}
										>
											<p>
												{'Time logs are based on '}

												<span
													className={
														styles['time-log-text']
													}
												>
													{isImportData
														? 'imported sheet'
														: 'system entries'}
												</span>
											</p>
										</Col>
									</>
								)}

								<Col span={24}>
									<Row gutter={50}>
										<Col span={12}>
											<div style={{ marginBottom: 8 }}>
												<span
													style={{
														fontWeight: 500,
														marginBottom: '10px',
														fontSize: '16px',
													}}
												>
													Pay Group{' '}
													<span
														style={{ color: 'red' }}
													>
														*
													</span>
													{usdCurrency && (
														<Tooltip
															title="Selected Pay Group Consist USD Currency"
															placement="top"
														>
															<ExclamationCircleOutlined
																style={{
																	color: '#584495',
																	marginLeft: 8,
																	fontSize:
																		'14px',
																	cursor: 'pointer',
																}}
															/>
														</Tooltip>
													)}
												</span>
											</div>
											<SelectDropdown
												placeholder="Pay Group"
												options={payGroupOptions}
												value={selectedPayGroup}
												disabled={onlyView}
												loading={
													isPayrollDetailsLoading
												}
												onChange={(value) => {
													handlePayGroup(value);
												}}
												size="large"
												required={true}
												helperText={
													currencyError
														? 'Please select a pay group with the same currency'
														: 'Pay group is required'
												}
												label="" // or remove this line if `label` is optional
												isError={
													payGroupError.payGroup ||
													currencyError
												}
												mode="multiple"
											/>
										</Col>

										{usdCurrency ? (
											<Col span={12}>
												<InputNumberField
													label="Exchange Rate"
													value={exchangeRate}
													isError={
														payGroupError.exchangeRate
													}
													name="Conversion Rate"
													onChange={
														handleCurrencyChange
													}
													placeholder="Enter exchange rate"
													helperText="Exchange rate is required"
													required={true}
													style={{
														paddingRight: '25px',
													}}
												/>
											</Col>
										) : (
											<Col span={12}></Col>
										)}
									</Row>
								</Col>
								{/* {!invalidText(selectedPayGroup) && (
									<Col
										span={24}
										style={{
											color: '#584495',
											paddingTop: '8px',
										}}
									>
										<Checkbox
											onChange={(e) =>
												setIsLastPayroll(
													e.target.checked
												)
											}
											checked={isLastPayroll}
										>
											Last payroll of respective pay group
										</Checkbox>
									</Col>
								)} */}
							</Row>
							<Row>
								<Col
									span={24}
									style={{
										marginTop: '12px',
										marginBottom: '-22px',
										paddingLeft: '25px',
									}}
								>
									<Form.Item>
										<Radio.Group
											onChange={handleRadioChange}
											value={radioValue}
										>
											<Radio
												value="employee"
												checked={true}
											>
												Remaining employees
											</Radio>
										</Radio.Group>
										<Radio.Group
											onChange={handleRadioChange}
											value={radioValue}
										>
											<Radio
												value="payGroupEmployees"
												checked={true}
											>
												Pay group employees
											</Radio>
										</Radio.Group>
									</Form.Item>
								</Col>
								<Col
									span={12}
									className={styles['employee-list']}
								>
									{isPayrollDetailsLoading ? (
										<>
											<div
												className={
													styles[
														'employee-listing-loader'
													]
												}
											>
												<Loader />
											</div>
										</>
									) : radioValue === 'employee' ? (
										<>
											<div
												className={
													styles['employee-header']
												}
											>
												Employees
											</div>
											<div
												className={
													styles[
														'employee-listing-container'
													]
												}
												style={{
													maxHeight: showSteps
														? '130px'
														: '230px',
													overflowY: 'auto',
												}}
											>
												{remainingEmployees &&
													remainingEmployees.length >
														0 &&
													remainingEmployees.map(
														(emp: any) => {
															return (
																<div
																	style={{
																		display:
																			'flex',
																	}}
																	className={
																		styles[
																			'employee-item'
																		]
																	}
																	key={emp.id}
																>
																	<div>
																		<span>
																			{
																				emp.label
																			}
																		</span>{' '}
																		|{' '}
																		<span
																			style={{
																				color: '#584495',
																			}}
																		>
																			{
																				emp.employeeId
																			}
																		</span>
																	</div>

																	{emp.isAdded ? (
																		<Button
																			className={
																				styles[
																					'employee-add-button'
																				]
																			}
																			disabled={
																				onlyView
																			}
																			onClick={() =>
																				removeEmployee(
																					emp.value
																				)
																			}
																		>
																			Remove
																		</Button>
																	) : (
																		<Button
																			className={
																				styles[
																					'employee-add-button'
																				]
																			}
																			disabled={
																				onlyView
																			}
																			onClick={() =>
																				addEmployee(
																					emp.value
																				)
																			}
																		>
																			Add
																		</Button>
																	)}
																</div>
															);
														}
													)}
											</div>
										</>
									) : (
										<>
											<div
												className={
													styles['employee-header']
												}
											>
												Employees
											</div>
											<div
												className={
													styles[
														'employee-listing-container'
													]
												}
												style={{
													maxHeight: showSteps
														? '130px'
														: '230px',
													overflowY: 'auto',
												}}
											>
												{payGroupEmployees &&
													payGroupEmployees.length >
														0 &&
													payGroupEmployees.map(
														(emp: any) => {
															return (
																<div
																	style={{
																		display:
																			'flex',
																	}}
																	className={
																		styles[
																			'employee-item'
																		]
																	}
																	key={emp.id}
																>
																	<div>
																		<span>
																			{
																				emp.label
																			}
																		</span>{' '}
																		|{' '}
																		<span
																			style={{
																				color: '#584495',
																			}}
																		>
																			{
																				emp.employeeId
																			}
																		</span>
																	</div>
																</div>
															);
														}
													)}
											</div>
										</>
									)}
								</Col>
							</Row>
						</Col>

						<Col span={9}>
							<PayGroupImage />
						</Col>
					</Row>
				</Form>
			</div>
		</>
	);
};
export default PayGroupSetupComponent;
